<template>
    <section>
        <page-header>
            <slot slot="title">{{ $t('global.search') }} <strong>{{ searchText }}</strong></slot>
            <slot slot="description">
                <v-input v-model="searchText"
                         custom-class="c-search-view"
                         autocomplete="off"
                         type="search"
                         :fluid="true"
                         :horizontal="true"
                         :name="`${_uid}-search`"
                         :placeholder="$t('global.search_bar_placeholder')"
                         :debounce-delay="400"
                         @enter="dispatchSearch">

                    <slot slot="suffix">
                        <button @click="dispatchSearch" class="c-button c-button--small" title="Zoeken">
                            <svgicon name="search"></svgicon>
                        </button>
                    </slot>
                </v-input>
            </slot>
        </page-header>

        <section class="o-wrapper o-wrapper--center">
            <section class="o-page-row--large">

                <div v-for="result in results" :key="result.Id" class="u-margin-bottom">
                    <div>

                    </div>


                    <router-link :to="{ name: 'ProductDetailview', params: { id: result.Id }}" class="result__title">
                        <strong>{{ result.Name }}</strong>
                    </router-link>
                    <span class="u-font-small">({{ result.Id }})</span>
                    <br/>
                    ErpId: {{ result.ErpId }}<br/>
                    Brand: {{ result.Brand }}
                </div>
                <div v-if="results.length === 0" class="u-padding u-text-align-center u-font-medium">
                    {{ $t('global.no_results') }}
                    <br>
                    <p class="u-font-default">{{ $t('edit_preorder.no_results') }}</p>
                </div>

            </section>
        </section>
    </section>
</template>

<script>
    import Vue from 'vue'
    import PageHeader from '@/components/common/PageHeader'
    import VInput from '@/components/form/Input'

    export default {
        components: {
            PageHeader,
            VInput
        },
        data() {
            return {
                searchText: this.$route.query.search
            }
        },
        created() {
            if (this.searchText) {
                this.dispatchSearch();
            }
        },
        watch: {
            '$route.query.search'(value) {
                this.searchText = value;
            }
        },
        computed: {
            results: {
                get() {
                    return this.$store.getters.productsByTerm;
                },
                set(value) {
                    return value;
                }
            }
        },
        methods: {
            dispatchSearch() {
                this.$store.dispatch('getProductsByTerm', {
                    params: {
                        search: this.searchText
                    }
                }).then((products) => {
                    this.results = products;
                });
            }
        },
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/private";
    .c-search-view {
        width: 500px;
    }
    .result__title {
        color: $color-base;
        text-decoration: none;
        &:visited { color: $color-base; }
        &:hover { color: $color-alpha; text-decoration: underline; }
    }
</style>


// WEBPACK FOOTER //
// src/views/common/Search.vue